<!--精准读书会-活动列表-->
<template>
    <div class="club-page-container">
        <!-- 标题区 -->
        <div class="club-page-header">
            <div class="club-page-title-box">
                <div class="club-page-title">{{itemInfo.itemMonth}} {{itemInfo.itemName}}</div>
                <div class="club-page-subtitle">{{itemInfo.itemDesc}}</div>
            </div>
            <div class="club-back-btn" @click="backPage">⇦返回</div>
        </div>

        <!-- 筛选工具栏 -->
        <div class="club-page-filter">
            <div class="filter-left">
                <div class="filter-item">
                    <span class="filter-label">学段</span>
                    <el-select class="filter-select" v-model="queryParams.periodKey" clearable placeholder="请选择" @change="handleFilterChange">
                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey"/>
                    </el-select>
                </div>
                <div class="filter-item">
                    <span class="filter-label">年级</span>
                    <el-select class="filter-select" v-model="queryParams.eventGrade" clearable placeholder="请选择" @change="handleFilterChange">
                        <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey"/>
                    </el-select>
                </div>
            </div>
            <div class="filter-right">
                <input class="club-search-input" type="text" placeholder="请输入关键词" v-model="queryParams.eventTheme" @keyup.enter="handleSearch"/>
                <div class="club-search-btn" @click="handleSearch">搜索</div>
            </div>
        </div>

        <!-- 活动列表 -->
        <div class="club-event-list" v-loading="loading">
            <div class="club-event-card" v-for="(item,index) in eventList" :key="index" @click="handleEventClick(item)">
                <div class="club-event-cover">
                    <img :src="item.eventCover" :alt="item.eventTheme"/>
                </div>
                <div class="club-event-info">
                    <div class="club-event-info-item" :title="item.eventTheme">
                        <span class="info-label">活动主题：</span>
                        <span class="info-value">{{item.eventTheme}}</span>
                    </div>
                    <div class="club-event-info-item" :title="(item.periodName || '') + '·' + (item.eventGradeName || '')">
                        <span class="info-label">学段年级：</span>
                        <span class="info-value">{{item.periodName}}·{{item.eventGradeName}}</span>
                    </div>
                    <div class="club-event-info-item">
                        <span class="info-label">活动时长：</span>
                        <span class="info-value">{{item.eventTime}}</span>
                    </div>
                </div>
            </div>
            <div class="club-empty-container" v-if="!loading && eventList.length===0">
                <dataEmpty title="暂无数据"/>
            </div>
        </div>

        <!-- 分页 -->
        <div class="club-page-pagination" v-if="total > 0">
            <pageTag :background="true"
                     :pageSizes="[12, 24, 36]"
                     :total="total"
                     v-model:page.sync="queryParams.pageNum"
                     v-model:limit.sync="queryParams.pageSize"
                     @pagination="pageList"/>
        </div>
    </div>
</template>

<script>
import {pageEvent, queryDict} from "@/api/admin/museum";
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";

export default {
    name: "readClubPage",
    components: {dataEmpty, pageTag},
    data() {
        return {
            loading:false,
            total:0,
            eventList:[],
            periodList:[],
            gradeList:[],
            /*分页查询读书会活动*/
            queryParams:{
                eventTheme:'',
                eventItem:'',
                periodKey:'',
                eventGrade:'',
                pageNum: 1,
                pageSize: 12,
            },
        }
    },
    computed: {},
    props:{
        itemInfo:{
            type: Object,
            default: () => ({})
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.initQuery();
        },
    },
    created() {
        this.handleQueryDict();
        this.initQuery();
    },
    mounted(){},
    methods: {
        /*初始化查询条件并查询*/
        initQuery(){
            if (!this.itemInfo.itemId) return;
            this.queryParams.eventTheme = '';
            this.queryParams.periodKey = '';
            this.queryParams.eventGrade = '';
            this.queryParams.pageNum = 1;
            this.queryParams.eventItem = this.itemInfo.itemId;
            this.pageList();
        },
        /*字典查询*/
        handleQueryDict() {
            queryDict({ code: "lession_xd_nj_xk" }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data || [];
                }
            });
            queryDict({ code: "grade_period" }).then(res => {
                if (res.data.code === 1) {
                    this.gradeList = res.data.data || [];
                }
            });
        },
        /*活动分页查询*/
        pageList(e) {
            this.loading = true;
            this.eventList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageEvent(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total || 0;
                    this.eventList = res.data.data.list || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        /*筛选与搜索*/
        handleFilterChange() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },
        handleSearch() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },
        handleEventClick(item){
            this.$emit('view-info', item);
        },
        backPage(){
            this.$emit('back-page');
        }
    }
}
</script>

<style scoped>
.club-page-container{
    width: 100%;
    height: 100%;
    padding: 10px 30px 20px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 标题区 */
.club-page-header{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}
.club-page-title-box{
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.club-page-title{
    font-weight: bold;
    color: #ff7f2e;
    font-size: 18px;
    line-height: 1.4;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.club-page-subtitle{
    color: #9a9a9a;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.club-back-btn{
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}

/* 筛选工具栏 */
.club-page-filter{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}
.filter-left{
    display: flex;
    align-items: center;
    gap: 24px;
}
.filter-item{
    display: flex;
    align-items: center;
    gap: 10px;
}
.filter-label{
    font-size: 14px;
    color: #4b5563;
}
.filter-select{
    width: 120px;
}
.filter-select :deep(.el-select__wrapper){
    min-height: 32px;
    font-size: 14px;
}
.filter-right{
    display: flex;
    align-items: center;
    gap: 10px;
}
.club-search-input{
    width: 200px;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    outline: none;
    font-size: 14px;
    box-sizing: border-box;
    background-color: #ffffff;
}
.club-search-input:focus{
    border-color: #ff7f2e;
}
.club-search-btn{
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    border: 1px solid #ff7f2e;
    border-radius: 6px;
    font-size: 14px;
    color: #ff7f2e;
    background-color: #ffffff;
    cursor: pointer;
    box-sizing: border-box;
}
.club-search-btn:hover{
    background-color: #ff7f2e;
    color: #ffffff;
}

/* 活动列表 */
.club-event-list{
    flex: 1;
    min-height: 0;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    align-content: flex-start;
    padding-top: 4px;
}
.club-event-card{
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1.5px solid #ff7f2e;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 12px;
    cursor: pointer;
    transition: all 0.25s ease;
}
.club-event-card:hover{
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.club-event-cover{
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 12px;
    background-color: #f3f4f6;
    border-radius: 6px;
}
.club-event-cover img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.club-event-info{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.club-event-info-item{
    width: 100%;
    font-size: 13px;
    color: #1f2937;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.info-label{
    color: #4b5563;
}
.info-value{
    color: #1f2937;
}
.club-empty-container{
    grid-column: 1 / -1;
    width: 100%;
}

/* 分页 */
.club-page-pagination{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 12px;
}
</style>
